import React, { useState } from 'react';
import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal'
import 'aframe';
import ReactPannellum, { getConfig } from "react-pannellum";

const Amenities = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showAModal, setShowAModal] = useState(false);
    const [showAModalData, setShowAModalData] = useState('');
    const [activeItem, setActiveItem] = useState(null);
    const [selectedView, setSelectedView] = useState('Interior');
    const [showAmenitiesPage, setShowAmenitiesPage] = useState(true);
    const [svgKey, setSvgKey] = useState(0);
    const [exteriorPoint, setExteriorPoint] = useState([
        {
            "id": "Green_Plaza_360_05",
            "amenities_name": "Gym",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Green_Plaza_360_05.jpg",
            "video_url": "/assets/images/videos/Gym.mp4"
        },
        {
            "id": "Green_Plaza_360_01",
            "amenities_name": "Kids Play",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Green_Plaza_360_01.jpg",
            "video_url": "/assets/images/videos/Kids_Play.mp4"
        },
        {
            "id": "Green_Plaza_360_02",
            "amenities_name": "Pool",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Green_Plaza_360_02.jpg",
            "video_url": "/assets/images/videos/Pool.mp4"
        },
        {
            "id": "Green_Plaza_360_03",
            "amenities_name": "Shop",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Green_Plaza_360_03.jpg",
            "video_url": "/assets/images/videos/Shop.mp4"
        },
        {
            "id": "Green_Plaza_360_04",
            "amenities_name": "Sitting Lounge",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Green_Plaza_360_04.jpg",
            "video_url": "/assets/images/videos/sitting_lounge.mp4"
        }
    ])
    const [amenitiesModal, setAmenitiesModal] = useState([
        {
            "id": "Normal_Bathroom",
            "amenities_name": "Gym",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Normal_Bathroom.jpg",
            "video_url": "/assets/images/videos/Gym.mp4"
        },
        {
            "id": "Kitchen",
            "amenities_name": "Kids Play",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Kitchen.jpg",
            "video_url": "/assets/images/videos/Kids_Play.mp4"
        },
        {
            "id": "Normal_Bedroom_02",
            "amenities_name": "Pool",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Normal_Bedroom_02.jpg",
            "video_url": "/assets/images/videos/Pool.mp4"
        },
        {
            "id": "Normal_Bedroom_01",
            "amenities_name": "Shop",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Normal_Bedroom_01.jpg",
            "video_url": "/assets/images/videos/Shop.mp4"
        },
        {
            "id": "Master_Bathroom",
            "amenities_name": "Sitting Lounge",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Master_Bathroom.jpg",
            "video_url": "/assets/images/videos/sitting_lounge.mp4"
        },
        {
            "id": "Master_Bedroom",
            "amenities_name": "Sitting Lounge",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Master_Bedroom.jpg",
            "video_url": "/assets/images/videos/sitting_lounge.mp4"
        },
        {
            "id": "Living_Room",
            "amenities_name": "Sitting Lounge",
            "dummy_image_thumbnail": "assets/images/images.svg",
            "image_thumbnail": "assets/images/amenities/images/Living_Room.jpg",
            "video_url": "/assets/images/videos/sitting_lounge.mp4"
        }
    ])
    const svgLoad = () => {
        const objTag = document.querySelector('object');
        if (objTag) {
            objTag.addEventListener('load', () => {
                const svg = objTag.getSVGDocument();
                Array.from(svg.getElementsByTagName('circle')).forEach(p => {
                    if (p.getAttribute('class') !== null && p.getAttribute('class').toLowerCase() === 'cls-1') {
                        p.setAttribute('cursor', 'pointer');
                        // p.addEventListener('mouseover', onIconHover);
                        // p.addEventListener('mouseleave', onIconOut);
                        p.addEventListener('click', onIconClick);
                        p.setAttribute('position', 'relative');
                    }
                });
            });
        }
    };

    const onIconHover = (ev) => {
        let t = ev.target;
        t.setAttribute('style', "opacity:0.9;fill:#AF8E54");
    }

    const onIconOut = (ev) => {
        let t = ev.target;
        t.setAttribute('style', "opacity:1;fill:#ffffff");
    }
    const config = {
        autoRotate: -2
    };
    const onIconClick = (ev) => {
        const t = ev.target;
        const currentId = t.getAttribute('id');
        // t.setAttribute('style', "opacity:0.3;fill:#AF8E54;fill-opacity:1;stroke:#ffffff;strokeWidth:3;strokeLinecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1");
        setShowAModal(true);
        t.classList.add('active');
        const activeItemIndex = amenitiesModal.findIndex(data => data.id === currentId);
        setActiveItem(activeItemIndex);
        amenitiesModal.forEach(data => {
            if (data.id === currentId) {
                setShowAModalData(data);
            }
        });
        const activeItemIndexExterior = exteriorPoint.findIndex(data => data.id === currentId);
        setActiveItem(activeItemIndexExterior);
        exteriorPoint.forEach(data => {
            if (data.id === currentId) {
                setShowAModalData(data);
            }
        });
    };
    const handleViewClick = (view) => {
        setSelectedView(view);
        setShowAmenitiesPage(false);
        setSvgKey((prevKey) => prevKey + 1); // Update the key to force re-render
    };
    const onIconTouchStart = () => {
        // Handle touch start logic
    };

    const onIconTouchEnd = () => {
        // Handle touch end logic
    };
    useEffect(() => {
        svgLoad(); // Load SVG when the component mounts or when key changes
    }, [svgKey]);
    return (
        <>
            <div className='position-relative' style={{ height: "100%" }}>
                {showAmenitiesPage && (
                    <div className="amenitiesPage row justify-content-around align-items-center" style={{ marginLeft: '70px', height: '100%', width: 'calc(100% - 70px)' }}>
                        <div className="col-6 pe-0 ps-0" onClick={() => handleViewClick('Interior')}>
                            <div className="interiorImageSection first">
                                <h3 className={`interiorHeading ${selectedView === 'Interior' ? 'active' : ''}`}>
                                    Interior
                                </h3>
                            </div>
                        </div>
                        <div className="col-6 ps-0" onClick={() => handleViewClick('Exterior')}>
                            <div className="exteriorImageSection second">
                                <h3 className={`interiorHeading ${selectedView === 'Exterior' ? 'active' : ''}`} >
                                    Exterior
                                </h3>
                            </div>
                        </div>
                    </div>
                )}
                <div className="amenitiesSection">
                    {selectedView === 'Interior' && (
                        <object data="assets/images/amenities/AL_Safa_Interior_Top.svg" aria-label="block view" />
                    )}
                    {selectedView === 'Exterior' && (
                        <object data="assets/images/amenities/AL_Safa_Exterior_Top.svg" aria-label="block view" />
                    )}
                    <button className='amenitiesClose' onClick={() => setShowAmenitiesPage(true)} style={{ position: "absolute", top: "2%", left: "85px", borderRadius: "5px", background: "transparent" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="#dc6b33" className="bi bi-arrow-left-circle" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                        </svg>
                    </button>
                </div>

                {/* </div> */}
                {showAModal ?
                    <div className='amenitiesModal' style={{ position: "absolute", top: "0", zIndex: "1" }}>
                        <div className='objectWidth1' >
                            <div className='position-relative video_section'>
                                {/* <a-scene>
                                    <a-sky src={showAModalData.image_thumbnail} rotation="0 250 0 0"></a-sky>
                                </a-scene> */}
                                <ReactPannellum
                                    id="1"
                                    sceneId="firstScene"
                                    imageSource={showAModalData.image_thumbnail}
                                    config={{
                                        autoLoad: true,
                                        mouseZoom: false, // Disable zoom for mouse
                                        disableZoom: true, // Disable zoom for touch devices
                                        hfov: 130, // Adjust this value to set the initial zoom level
                                    }}
                                />
                                <button className='amenitiesClose' onClick={() => setShowAModal(false)} style={{ position: "absolute", top: "2%", left: "85px", borderRadius: "5px", background: "transparent" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="#dc6b33" className="bi bi-arrow-left-circle" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    :
                    ""}
            </div>
            <div >
                <Modal
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    className='amenitiesImageBigModal'
                >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <img src={showAModalData.image_thumbnail} className="img-fluid" alt="Amenity" />
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}
export default Amenities;